import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { updateCart } from '../../actions/Cart';
import { getCategories } from '../../actions/Categories';
import { getAllItems } from '../../actions/Items';
import lazyLoad from '../../assets/js/lazy-load';
import CONSTANTS from '../../constants';
import ItemModal from '../items/ItemModal';
import PopularItem from './Popularitem';

class PopularItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      selectedItem: null
    };
  }

  componentDidMount() {
    if (!this.props.items) this.props.getAllItems(this.props._location, this.props.history);
    if (!this.props.categories)
      this.props.getCategories(
        this.props._location.menu_blob,
        this.props._location.loc_id,
        this.props.history
      );
  }

  onItemSelected(item) {
    this.setState({ selectedItem: item });
    this.toggleModal();
  }

  showItemDetails(item) {
    this.props.history.push(
      `${CONSTANTS.BASE_URL}${this.props._location.slug}/menu/${item.menu_id}`
    );
  }

  toggleModal() {
    this.setState({ showModal: !this.state.showModal });
  }

  componentDidUpdate() {
    let banners = document.querySelectorAll('.lazy-bg');
    if (banners.length > 0) lazyLoad(banners, { background: true });
  }

  render() {
    let { _location, popularItems, categories } = this.props;
    if (popularItems && categories && popularItems.length > 0) {
      return (
        <>
          <ItemModal
            isOrderingEnabled={this.props.isOrderingEnabled}
            toggleModal={this.toggleModal.bind(this)}
            item={this.state.selectedItem}
            location={_location}
            showModal={this.state.showModal}
            updateCart={this.props.updateCart}
          />
          <div
            className={`items horizontal-scroll ${CONSTANTS.MENU.POPULAR_CATEGORY} `}
            data-category-id={`category-${CONSTANTS.MENU.POPULAR_CATEGORY}`}
          >
            {popularItems.map((item, index) => {
              return (
                <React.Fragment>
                  <PopularItem
                    item={item}
                    categories={categories}
                    onItemClick={this.onItemSelected.bind(this, item)}
                  />
                </React.Fragment>
              );
            })}
          </div>
        </>
      );
    }
    return '';
  }
}
function mapStateToProps(state) {
  const { location, popularItems, categories, items } = state;
  return { _location: location, popularItems, categories, items };
}
export default withRouter(
  connect(mapStateToProps, { getAllItems, getCategories, updateCart })(PopularItems)
);
